import { Outlet } from "react-router";
import { OrgProvider } from "../../org/providers";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";

export function OrgLayout() {
  return (
    <WorkspaceScreen wide>
      <OrgProvider>
        <Outlet />
      </OrgProvider>
    </WorkspaceScreen>
  );
}
